import { Link } from 'react-router-dom'

const child = {
  update_link: function update_link(documentId, queryDetailId, data) {
    return <Link to={`/custom/child.display_form?in_case_id=${documentId}`}>Update Child Record Info</Link>
  }
}

export default child
